// extracted by mini-css-extract-plugin
export default {"sideswipe":"_3a_AdsNOdg0YBZ878tnGWt"};